const GetUserLocation=(showPosition, showPositionError)=>{
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showPositionError);
    } else {
        console.log("Geolocation is not supported by this browser.");
    }
} 

export default GetUserLocation;
